export const renewalColumns = ({
  selectedIds = [],
  handleSelect,
  handleSelectAll,
  totalRows = 0,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),
    render: (row) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(String(row.id))}
        onChange={() => handleSelect?.(row.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },

  {
    id: "organization",
    label: "Organization",

    render: (row) => {
      const orgName =
        typeof row.organization === "string"
          ? row.organization
          : (row.organization?.name || row.organization_name || "-");
      const dealTitle =
        typeof row.deal === "string"
          ? row.deal
          : (row.deal?.title || row.lead?.title || "-");

      return (
        <div className="renewal-org">
          <div className="renewal-org-name">
            {orgName}
          </div>

          <div className="renewal-plan">
            {dealTitle}
          </div>
        </div>
      );
    },

    exportValue: (row) =>
      typeof row.organization === "string"
        ? row.organization
        : (row.organization?.name || row.organization_name || ""),

    searchValue: (row) => {
      const org =
        typeof row.organization === "string"
          ? row.organization
          : (row.organization?.name || row.organization_name || "");
      const deal =
        typeof row.deal === "string"
          ? row.deal
          : (row.deal?.title || row.lead?.title || "");
      return `${org} ${deal}`.trim();
    },
  },

  {
    id: "next_renewal_date",
    label: "Next Renewal Date",

    render: (row) => row.next_renewal_date || "-",

    exportValue: (row) => row.next_renewal_date || "",
    searchValue: (row) => row.next_renewal_date || "",
  },

  {
    id: "remaining_days",
    label: "Remaining Days",

    render: (row) => {
      const days = Number(row.remaining_days ?? row.expiry_in_days ?? 0);
      const autoLeadCode = row.auto_lead?.lead_code || (row.auto_lead_id ? `Lead #${row.auto_lead_id}` : null);

      let className = "days-badge";

      if (days <= 30) {
        className += " critical";
      } else if (days <= 60) {
        className += " warning";
      } else if (days <= 90) {
        className += " upcoming";
      } else {
        className += " safe";
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
          <span className={className}>
            {days} Days
          </span>
          {autoLeadCode && (
            <span
              style={{
                fontSize: "11px",
                fontWeight: 600,
                color: "#059669",
                background: "#ecfdf5",
                padding: "2px 6px",
                borderRadius: "4px",
                border: "1px solid #a7f3d0",
                display: "inline-flex",
                alignItems: "center",
                gap: "3px"
              }}
              title="Auto-generated Lead from Renewal"
            >
              ✓ {autoLeadCode}
            </span>
          )}
        </div>
      );
    },

    exportValue: (row) => row.remaining_days ?? row.expiry_in_days ?? "",
    searchValue: (row) => {
      const days = row.remaining_days ?? row.expiry_in_days;
      return days != null ? `${days} Days` : "";
    },
  },

  {
    id: "notes",
    label: "Notes",

    render: (row) => row.remarks || row.notes || row.remark || row.description || "-",

    exportValue: (row) => row.remarks || row.notes || row.remark || row.description || "",
    searchValue: (row) => row.remarks || row.notes || row.remark || row.description || "",
  },

  {
    id: "assigned_to",
    label: "Assigned User",

    render: (row) =>
      typeof row.assigned_to === "string"
        ? row.assigned_to
        : (row.assigned_to?.name || "-"),

    exportValue: (row) =>
      typeof row.assigned_to === "string"
        ? row.assigned_to
        : (row.assigned_to?.name || ""),

    searchValue: (row) =>
      typeof row.assigned_to === "string"
        ? row.assigned_to
        : (row.assigned_to?.name || ""),
  },
];